import bcrypt from 'react-native-bcrypt';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'isaa... Remove this comment to see the full error message
import isaac from 'isaac';

// This switches bcrypt to use a more cryptographically secure method than MATH.Random for encryption
/* istanbul ignore next */
bcrypt.setRandomFallback((len: any) => {
  /* istanbul ignore next */
  const buf = new Uint8Array(len);
  /* istanbul ignore next */
  return buf.map(() => Math.floor(isaac.random() * 256));
});

export async function checkPin(pin: any, hash: any) {
  return await bcrypt.compareSync(pin, hash);
}

export function hashPin(pin: any, salt: any) {
  return bcrypt.hashSync(pin, salt);
}
